<template>
<span style="font-weight: bold;" v-if="includeDayOfWeek">{{ dayOfWeek }}</span>
<span style="font-weight: normal;">{{ displayDate }}</span>
</template>

<script>
import dayjs from 'dayjs'

export default {
    name: 'DateDisplay',

    computed: {
        dayOfWeek() {
            return dayjs(this.calendar_date).format('dddd ')
        },
        displayDate() {
            return dayjs(this.calendar_date).format('MMMM D, YYYY')
        },
    },

    props: {
        calendar_date: {
            type: String,
            default: '1971-01-01'
        },
        includeDayOfWeek: {
            type: Boolean,
            default: true,
        },
    }
}
</script>